import { render, staticRenderFns } from "./MessagesProgrammes.vue?vue&type=template&id=5b9718f4"
import script from "./MessagesProgrammes.vue?vue&type=script&lang=js"
export * from "./MessagesProgrammes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports